<div id="csi">
  <div class="csi-sidebar">
    <p class="title">{{ 'doktar_app.account.enterprises.contracts' | translate }}</p>
    <div class="enterprise-info">
      @if (!enterpriseLoading) {
        <div class="d-flex align-items-center gap-2">
          <div class="enterprise-logo-container">
            {{ enterpriseNameAbbreviation | uppercase }}
          </div>
          <p class="enterprise-name">{{ (csiService.selectedEnterprise$ | async)?.name }}</p>
        </div>

        <p class="change-enterprise-btn" (click)="opChangeEnterprise.toggle($event)"><span>Change Enterprise</span></p>
        <p-popover #opChangeEnterprise [styleClass]="'change-enterprise-btn'">
          <div class="popover-container">
            <div class="search-device-input">
              <dk-search-icon />

              <input
                type="text"
                [placeholder]="'doktar_app.common.search_placeholder' | translate"
                [(ngModel)]="searchText" />
            </div>

            <div class="options-container">
              @if (enterpriseOptions?.length > 0) {
                @for (enterprise of enterpriseOptions; track enterprise; let index = $index) {
                  <div
                    class="option"
                    [class.border-bt]="index < enterpriseOptions?.length - 1"
                    (click)="selectedEnterprise = enterprise">
                    <div class="">
                      <p class="device-name">{{ enterprise.name }}</p>
                      <p
                        class="device-asset-id m-0 cursor-pointer"
                        [dkClipboard]="enterprise.enterpriseId"
                        (click)="$event.stopPropagation()">
                        {{ enterprise?.enterpriseId | truncate: 4 }}
                      </p>
                    </div>
                    <div>
                      @if (selectedEnterprise?.enterpriseId === enterprise.enterpriseId) {
                        <i class="ph-fill ph-radio-button icon"></i>
                      } @else {
                        <i class="ph ph-circle icon"></i>
                      }
                    </div>
                  </div>
                }
              } @else {
                <p class="not-found-device">{{ 'doktar_app.account.enterprises.devices.empty' | translate }}</p>
              }
            </div>
            <!-- <div class="note mb-1">
            <span class="icon">
              <i class="ph-fill ph-info"></i>
            </span>
            <span>{{ 'doktar_app.services.weather_soil_and_pest.change_device_alert' | translate }}</span>
          </div> -->

            <dk-button
              severity="primary"
              [label]="'doktar_app.common.select' | translate"
              [disabled]="!selectedEnterprise"
              (onClick)="selectEnterprise(selectedEnterprise)" />
          </div>
        </p-popover>
      } @else {
        <p-skeleton width="100%" height="60px" styleClass="" />
      }
    </div>
    <div class="csi-menus">
      @if (!enterpriseLoading) {
        @for (menu of csiMenus; track menu) {
          <a (click)="navigateToMenu(menu.route)" [class.active]="isRouteActivated(menu.route)">
            <div class="menu">
              <i [class]="menu.icon"></i>
              <span>{{ menu.label | translate }}</span>
            </div>
          </a>
        }
      } @else {
        @for (menu of csiMenus; track menu) {
          <div class="menu">
            <p-skeleton width="100%" height="40px" styleClass="mb-3" />
          </div>
        }
      }
    </div>
  </div>
  <div class="csi-content">
    @if (!enterpriseLoading) {
        <div class="csi-header-wrapper p-3">
          <app-csi-header
            [breadcrumbs]="headerState.breadcrumbs"
            [header]="headerState.header"
            [description]="headerState.description" />
        </div>
      <router-outlet />
    } @else {
      <div class="p-3">
        <p-skeleton width="100%" height="95px" styleClass="mt-3 mb-3" />
        <p-skeleton width="100%" height="90vh" styleClass=" mb-4" />
      </div>
    }
  </div>
</div>
